module.exports = __webpack_public_path__ + "static/media/thumbnail_Karte Standorte.7040f6aa.png";